export const loginStyles = {
  mainWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2rem',
    width: { xs: '90%', md: '90%' },
  },
  formWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '@media (min-width: 800px)': {
      height: '100%',
    },
    '@media (max-width: 800px)': {
      padding: '40px 0px',
    },
    gap: '2rem',
  },
  formWrapper1: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    // height: '100%',
    gap: '2rem',
    '@media (max-width: 800px)': {
      padding: '40px 0px',
    },
  },
  wrapper: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: '.5rem',
    cursor: 'pointer',
  },
  forgotLink: {
    color: '#286efb',
    textAlign: 'start',
    fontSize: '14px',
  },
};
